





































import { Cadastros } from "@/services/dashboard.service";
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";

import ChartDoughnut from "@/shared/components/chart-doughnut.vue";
import GraficoLegenda from "../GraficoLegenda.vue";

@Component({
  components: { ChartDoughnut, GraficoLegenda },
})
export default class GraficoDonutCadastros extends Vue {
  centro = {
    title: "Cadastros",
    value: 0,
  };

  options: Chart.ChartOptions = {
    tooltips: {
      enabled: false
    },
    cutoutPercentage: 76,
    responsive: false
  };

  @Prop() readonly loading!: boolean;
  @Prop() readonly value!: Cadastros[];
  @Prop() readonly date!: string | null | Date;
  @Prop() readonly height!: number;
  @Prop() readonly width!: number;

  get dataSet(): Chart.ChartDataSets[] {
    const source = this.value ?? [];
    return [
      {
        backgroundColor: [
          "#FF2D55",
          "#FF9EB1",
        ],
        data: [
          source.length > 0 ? source.find(x => x.data === this.date)?.quantidadeApp : 0,
          source.length > 0 ? source.find(x => x.data === this.date)?.quantidadeSite : 0
        ],
      },
    ];
  }

  @Watch("value")
  onValueChange() {
    const source = this.value ?? [];
    this.centro.value =
      source.length > 0
        ? source.find(x => x.data === this.date)?.quantidadeSite! + source.find(x => x.data === this.date)?.quantidadeApp! : 0;
  }

  mounted() {
    this.onValueChange();
  }

}
